import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";

const TITLES = {
  "refund-policy": "Return & Refund Policy",
  "shipping-policy": "Shipping Policy",
  "privacy-policy": "Privacy Policy",
  "terms-of-service": "Terms of Service",
};

export default function Policy() {
  const { handle } = useParams();
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/policies").then((r) => setPolicies(r.data.policies || [])).catch(() => {}).finally(() => setLoading(false));
  }, [handle]);

  const policy = policies.find((p) => p.handle === handle);

  return (
    <main className="max-w-[900px] mx-auto px-5 sm:px-8 py-16 min-h-[60vh]" data-testid="policy-page">
      <Seo
        title={policy?.title || TITLES[handle] || "Policy"}
        description={`${policy?.title || TITLES[handle] || "Policy"} for Kurti Connection USA.`}
        path={`/policies/${handle}`}
        noindex
      />
      <div className="overline text-[#B84A3B] mb-3">Kurti Connection USA</div>
      <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-8" data-testid="policy-title">
        {policy?.title || TITLES[handle] || "Policy"}
      </h1>

      {loading ? (
        <div className="space-y-3">
          {[...Array(6)].map((_, i) => <div key={i} className="h-4 bg-[#EEEEE8] animate-pulse" style={{ width: `${70 + (i % 3) * 10}%` }} />)}
        </div>
      ) : policy ? (
        <div
          className="policy-body font-body text-[#333] leading-relaxed space-y-3"
          data-testid="policy-body"
          dangerouslySetInnerHTML={{ __html: policy.body }}
        />
      ) : (
        <div data-testid="policy-empty">
          <p className="text-[#6E6E69]">This policy isn&apos;t available right now.</p>
          <Link to="/" className="inline-block mt-4 text-[0.72rem] font-mono tracking-[0.15em] uppercase text-[#B84A3B] border-b border-[#B84A3B] pb-0.5">Back to home</Link>
        </div>
      )}
    </main>
  );
}
